import { Injectable } from '@angular/core';
var ReflectionAction = /** @class */ (function () {
    function ReflectionAction() {
    }
    ReflectionAction.prototype.getTargets = function (params, rec) {
        var _params = JSOG.parse(JSON.stringify(params));
        var targets = [];
        if (typeof _params.targetComponent !== 'undefined') {
            var tars = this.getTargetComponent(_params.targetComponent);
            targets.push({
                targets: tars,
                rec: rec
            });
        }
        if (typeof _params.targetOption !== 'undefined' && _params.targetOption instanceof Array) {
            targets = targets.concat(this.getTargetOption(_params.targetOption, rec));
        }
        if (typeof _params.targetComponent === 'undefined' && typeof _params.targetOption === 'undefined' && typeof _params.targets !== 'undefined' && _params.targets instanceof Array) {
            for (var _i = 0, _a = _params.targets; _i < _a.length; _i++) {
                var tar = _a[_i];
                if (typeof tar.targetComponent !== 'undefined') {
                    var tars = this.getTargetComponent(tar.targetComponent);
                    targets.push({
                        targets: tars,
                        rec: (rec[tar.apiName] || {})
                    });
                }
                if (typeof tar.targetOption !== 'undefined' && tar.targetOption instanceof Array) {
                    targets = targets.concat(this.getTargetOption(tar.targetOption, rec[tar.apiName] || {}));
                }
            }
        }
        return targets;
    };
    ReflectionAction.prototype.getTargetComponent = function (target) {
        var targets = [];
        if (typeof target === 'string') {
            targets.push(target);
        }
        else if (Array.isArray(target)) {
            targets = target;
        }
        return targets;
    };
    ReflectionAction.prototype.getTargetOption = function (target, rec) {
        var targets = [];
        for (var _i = 0, target_1 = target; _i < target_1.length; _i++) {
            var tar = target_1[_i];
            if (!tar.optionCodeKey.match(/^\$/) || !tar.optionDisplayKey.match(/^\$/)) {
                continue;
            }
            var codeList = jsonpath.query(rec, tar.optionCodeKey);
            var displayList = jsonpath.query(rec, tar.optionDisplayKey);
            var options = [];
            for (var i = 0; i < codeList.length; i++) {
                options.push({ code: codeList[i], display: displayList[i] });
            }
            targets.push({
                targets: [],
                targetOption: tar,
                rec: options
            });
        }
        return targets;
    };
    ReflectionAction.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ReflectionAction.ctorParameters = function () { return []; };
    return ReflectionAction;
}());
export { ReflectionAction };
var Reflection = /** @class */ (function () {
    function Reflection() {
    }
    return Reflection;
}());
var Target = /** @class */ (function () {
    function Target() {
    }
    return Target;
}());
var TargetOption = /** @class */ (function () {
    function TargetOption() {
    }
    return TargetOption;
}());
var ReflectionParams = /** @class */ (function () {
    function ReflectionParams() {
    }
    return ReflectionParams;
}());
//# sourceMappingURL=reflection.action.js.map